//in ng-select, radiobutton, mat-toggle-button, mat-select-- comboMap
export const comboMap = { 0: 'No', 1: 'Yes' };

//in dataTable attributes- cols
export const columnDataTable = {
  columnName: 'Designation',
  columnId: 'designation',
  placeholder: 'Place desig',
  width: 20,
  isLink: true,
  type: null,
  headerAlign: 'center',
  align: 'center',
  icons: false,
  sortable: true,
  displayable: true,
  defaultValue: 'imdefault',
  searchable: true,
};
export const colsJ = [
  {
    columnName: 'Designation',
    columnId: 'designation',
    placeholder: 'Place desig',
    width: 20,
    isLink: true,
    type: null,
    headerAlign: 'center',
    align: 'center',
    icons: false,
    sortable: true,
    displayable: true,
    defaultValue: 'imdefault',
    searchable: true,
  },
  {
    columnName: 'Department',
    columnId: 'department',
    placeholder: 'Place desig',
    width: 20,
    isLink: true,
    type: null,
    headerAlign: 'center',
    align: 'center',
    icons: false,
    sortable: true,
    displayable: true,
    defaultValue: 'imdefault',
    searchable: true,
  },
];

// in  dg-listBox -columnConfig
export const columnConfigJ = [
  {
    name: 'folderName',
    displayName: 'Name',
  },
  {
    name: 'folderDesc',
    displayName: 'Description',
  },
];
// in mat-table - MatTableColumnConfig
export const MatTableColumnConfig = ['folderId', 'folderName'];

// in dg-grid--- gridConfig
export const gridConfigJ = {
  id: 'draftId', //to uniquely identify rows for selecting values
  showSearch: true,
  showColoredRowText: false,
  showLegend: false,
  pageSize: 20,
  isRowSelectable: false, //changed from showcheckbox
  allowMultiRowSelection: true, //chagned from singleSelectionAllowed
  linkColumns: [{ attributeNameToShowLink: 'draftId' }], // changed from gridLinkVOLst
  legends: [{ attributeName: 'showChild', color: 'red', legendName: 'New' }], //chagned from GridAttributeColorMpgVOn
  columnHeaders: [], // gridAttributeColumnHeaderMpgVOLst
  showColumnsWithWidth: [{ name: 'draftStatus', width: '150' }], //showAttributeNameLst
  externalPaging: false,
  gridDataService: {
    url: '/',
    method: 'GET',
    input: {
      startPage: '1',
    },
  },
  activePage: 1,
  totalRows: 35,
};

// in dg-apptree- treeDataApiUrl
export const treeDataApiUrlSt =
  '/admin/organization-search-details?chiledPerentTreeResponceFlag=TRUE&prntId=54&isFromOMS=TRUE';

// in dg-apptree- nodeDataUrl
export const nodeDataApiUrlSt = '/admin/organization-details?orgId=';

// in dg-apptree nodeInsertUrl
export const nodeInsertApiUrl = '/admin/insert-new-organization-detailss';
